import { useCallback, useState } from "react";
import { useSelectedWatchlist } from "../../Watchlists/hooks/useSelectedWatchlist";
import {
  EARNINGS_ALL_STORAGE_KEY,
  EARNINGS_PREFERRED_WATCHLIST_NAME,
  EARNINGS_STORAGE_KEY,
} from "../earningsSelection";

// Storage can throw in private mode and in the Capacitor WebView; both
// accessors degrade to "one list", the hub's long-standing default.
const readAll = (): boolean => {
  try {
    return localStorage.getItem(EARNINGS_ALL_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

const writeAll = (all: boolean): void => {
  try {
    if (all) localStorage.setItem(EARNINGS_ALL_STORAGE_KEY, "1");
    else localStorage.removeItem(EARNINGS_ALL_STORAGE_KEY);
  } catch {
    // The choice just won't persist to the next launch.
  }
};

/**
 * Which lists the Earnings hub shows: one (the Earnings selection the company
 * page also bookmarks into) or all of them.
 */
export const useEarningsScope = () => {
  const selection = useSelectedWatchlist({
    storageKey: EARNINGS_STORAGE_KEY,
    preferName: EARNINGS_PREFERRED_WATCHLIST_NAME,
  });
  const [all, setAll] = useState(readAll);
  const { selectWatchlist } = selection;

  const selectAll = useCallback(() => {
    writeAll(true);
    setAll(true);
  }, []);
  const selectList = useCallback(
    (watchlistId: string | null) => {
      writeAll(false);
      setAll(false);
      selectWatchlist(watchlistId);
    },
    [selectWatchlist],
  );

  return {
    ...selection,
    all,
    selectAll,
    selectList,
    /** For the feed and the upcoming rows: null means every list. */
    scopeId: all ? null : selection.selectedWatchlistId,
  };
};
